module.exports = __webpack_public_path__ + "img/icon-bank-search.0ed87d54.svg";